// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__19tWm","notes":"Notes_notes__2ZW1O","note":"Notes_note__1MJCy","markdown":"Notes_markdown__39ZHA"};